// extracted by mini-css-extract-plugin
export default {"table--empty":"Table_table--empty__p6wid","table-row--odd":"Table_table-row--odd__YjJxa","table-row--clickable":"Table_table-row--clickable__Z4Jqz"};